import { render, staticRenderFns } from "./AddSizeView.vue?vue&type=template&id=ceb8891c"
import script from "./AddSizeView.vue?vue&type=script&lang=js"
export * from "./AddSizeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports